import { LoaderSpinner } from '@vw-marketing/us-components';
import React, { useState, useEffect } from 'react';
import { createLaunchDarklyProvider } from '../services/launch-darkly-service';

interface LaunchDarklyProviderProps {
  clientId: string; // LaunchDarkly clientId
  children: React.ReactNode;
}

type ProviderComponent = React.FC<{ children: React.ReactNode }>;

export const LaunchDarklyProvider: React.FC<LaunchDarklyProviderProps> = ({
  clientId,
  children,
}) => {
  const [LDProvider, setLDProvider] = useState<null | ProviderComponent>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {

    const initLaunchDarkly = async () => {
      try {
        if(!clientId) return;
        setLoading(true);
        const Provider = await createLaunchDarklyProvider(clientId);
        setLDProvider(() => Provider);
      } catch (error) {
        console.error('Failed to initialize LaunchDarkly:', error);
        // Provide a fallback that just renders the app without LaunchDarkly
        setLDProvider(() => ({ children }) => <>{children}</>);
      } finally {
        setLoading(false);
      }
    };

    initLaunchDarkly();
  }, [clientId]);

  if (loading) {
    return <LoaderSpinner />;
  }

  return LDProvider ? <LDProvider>{children}</LDProvider> : <>{children}</>;
};

export default LaunchDarklyProvider;
